export default [
    {
      path: '/product_center/CI_decision',
      name: 'CI_decision',
      component: () => import('@/pages/product_center/findata/CI_decision.vue')
    },
    {
      path: '/product_center/CI_market',
      name: 'CI_market',
      component: () => import('@/pages/product_center/findata/CI_market.vue')
    },
    {
      path: '/product_center/CI_risk',
      name: 'CI_risk',
      component: () => import('@/pages/product_center/findata/CI_risk.vue')
    },
    {
      path: '/product_center/enterprise_date',
      name: 'enterprise_date',
      component: () => import('@/pages/product_center/findata/enterprise_date.vue')
    },
    {
      path: '/product_center/center_bank_query',
      name: 'center_bank_query',
      component: () => import('@/pages/product_center/findata/center_bank_query.vue')
    },
    {
      path: '/product_center/self_service_platform',
      name: 'self_service_platform',
      component: () => import('@/pages/product_center/findata/self_service_platform.vue')
    },
    {
      path: '/product_center/KSpider',
      name: 'KSpider',
      component: () => import('@/pages/product_center/kanas/KSpider.vue')
    },
    {
        path: '/product_center/KMonster',
        name: 'KMonster',
        component: () => import('@/pages/product_center/kanas/KMonster.vue')
    },
    {
        path: '/product_center/KStream',
        name: 'KStream',
        component: () => import('@/pages/product_center/kanas/KStream.vue')
    },
    {
        path: '/product_center/KLake',
        name: 'KLake',
        component: () => import('@/pages/product_center/kanas/KLake.vue')
    },
    {
        path: '/product_center/KSync',
        name: 'KSync',
        component: () => import('@/pages/product_center/kanas/KSync.vue')
    },
    {
        path: '/product_center/KTunnel',
        name: 'KTunnel',
        component: () => import('@/pages/product_center/kanas/KTunnel.vue')
    },
    {
        path: '/product_center/KCache',
        name: 'KCache',
        component: () => import('@/pages/product_center/kanas/KCache.vue')
    },
    {
        path: '/product_center/draco_db',
        name: 'draco_db',
        component: () => import('@/pages/product_center/kanas/draco_db.vue')
    },
    {
      path: '/product_center',
      name: 'product_center',
      component: () => import('@/pages/product_center/index.vue')
    }
]




// WEBPACK FOOTER //
// ./src/router/product_center.js